import React from 'react';
import ReactDOM from 'react-dom';
import {inject, observer, Provider} from 'mobx-react';
import store from './store';
import {HashRouter as Router, Route, Switch} from 'react-router-dom';
import Food from './components/Food';
import Guide from './components/Guide';
import Banner from './components/Banner';
import Amorous from './components/Amorous';
import Hotspot from './components/Hotspot';
import Line from './components/Line';
// import Activity from './components/Activity';
import ActivityNew from './components/ActivityNew';
import QRCode from './components/QRCode';
import HotRec from './components/HotRec';
import Economy from './components/Economy';
import HandBook from './components/HandBook';
import Book from './components/Book';
import './index.scss';
const invokeShare = require('@qnpm/vc_share').default;

hysdk.config({
    debug: false,
    wechatScriptUrl: '//res.wx.qq.com/open/js/jweixin-1.3.2.js'
});
const shareConfig = {
    title: '浪漫之都，时尚大连',
    text: '浪漫之都，时尚大连',
    imgUrl: 'https://s.qunarzz.com/vacation_tuan/2022/dalian/share.jpg',
    link: location.href
};
hysdk.ready(() => {
    hysdk.navRefresh({
        title: {
            style: 'text',
            text: document.title
        },
        right: {
            style: 'icon',
            icon: '\uf0cc'
        }
    });
    hysdk.onNavClick({
        success: (data, callback) => {
            switch (data.button) {
                case 'left':
                    if(location.href.match('/book')) {
                        history.go(-1);
                        callback({data: true});
                    }
                    break;
                case 'right':
                    invokeShare(shareConfig);
                    break;
            }
        }
    });
});
@inject('store')
@observer
class App extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.store.requestData();
    }

    render() {
        const {curVideoUrl, displayVideo, hidePopup} = this.props.store;

        return <div className="container" id="container">
            <Banner />
            <Amorous />
            <Line />
            <ActivityNew />
            <Hotspot />
            <Guide />
            <HotRec />
            <Food />
            <HandBook type="hand"/>
            <HandBook type="camp"/>
            <Economy/>
            <QRCode />
            {
                displayVideo ? <PopupBox>
                    <div className="video-container">
                        <div className="video-box">
                            <video controls autoPlay className="video">
                                <source src={curVideoUrl} />
                            </video>
                            <div className="iconfont video-close" onClick={() => hidePopup()}>
                                &#xf3f4;
                            </div>
                        </div>
                    </div>
                </PopupBox> : null
            }
        </div>;
    }
}

// 弹出层
class PopupBox extends React.Component {
    render() {
        return (
            <div>
                <div className="popup-mask" />
                <div className="popup-content">{this.props.children}</div>
            </div>
        );
    }
}
class FinalApp extends React.Component {
    render() {
        return (
            <Router>
                <Switch>
                    <Route path="/" exact component={App}/>
                    <Route path="/book/:type" component={Book} />
                </Switch>
            </Router>
        );
    }
}
ReactDOM.render(
    <Provider store={store}>
        <FinalApp />
    </Provider>,
    document.getElementById('app')
);